import styled from "@emotion/styled";

import { commonColors } from "application/theme";

import { LabelStyledProps } from "./models";

export const LabelStyled = styled("label")<LabelStyledProps>`
  display: flex;
  align-items: flex-start;

  color: ${commonColors.grey900};
  font-family: Unica77;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.07px;

  a {
    color: ${commonColors.blue700};
    text-decoration: none;
  }

  span.MuiButtonBase-root.MuiCheckbox-root.MuiCheckbox-colorPrimary {
    padding: 0 8px 0 0;
    margin-top: -4px;

    &:hover {
      background-color: unset;
    }
  }

  svg[data-testid="CheckBoxOutlineBlankIcon"].MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium {
    path {
      fill: ${({ hasError }) =>
        hasError ? commonColors.red700 : commonColors.grey300};
    }
  }
`;
